<template lang="pug">
  .text-field.input-field
    label {{ label }}
    input(
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :required="required"
      :class="textType"
      @input="$emit('input', $event.target.value)"
    )
</template>

<style lang="scss" scoped>
.text-field {
  background-color: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
}

label {
  @extend %label-text;
  margin-left: 16px;
  white-space: nowrap;
}

input {
  height: 56px;
  width: 100%;
  @extend %input-text;
  margin-left: 20px;
  margin-right: 20px;

  &.secure {
    -webkit-text-security: disc;
    -moz-text-security: disc;
  }

  @include placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
}
</style>

<script>
export default {
  props: {
    label: { type: String },
    value: { type: String },
    type: { type: String, default: 'text' },
    placeholder: { type: String },
    secure: { type: Boolean, default: false },
    autocomplete: { type: String, default: 'off' },
    required: { type: Boolean, default: true },
  },
  computed: {
    textType() {
      return this.secure ? 'secure' : 'plain'
    },
  },
}
</script>
